export default __webpack_public_path__ + "static/media/icon-twitch.d1d9864f.svg";